import ErrorBoundaryFallBack from '@/components/custom/fallback-view/error-boundary-fallback';
import LoadingFallback from '@/components/custom/fallback-view/loading-fallback';
import { useAnalyticsAccess } from '@/hooks/utils/use-analytics-access';
import loadable from '@loadable/component';
import { useAxiosInterceptor } from '@/hooks/utils/use-axios-interceptor';
import { Navigate, Outlet, createBrowserRouter } from 'react-router';
import { routerPaths } from './router-paths';

const AppWrapper = () => {
  useAxiosInterceptor();
  return <Outlet />;
};

const Layout = loadable(() => import('@/components/custom/layout/layout'), {
  fallback: <LoadingFallback />,
});

const Login = loadable(() => import('@/pages/login-page'), {
  fallback: <LoadingFallback />,
});

const CallCenter = loadable(() => import('@/pages/call-center'), {
  fallback: <LoadingFallback />,
});

const Analytics = loadable(
  async () => {
    const { default: AnalyticsPage } = await import('@/pages/analytics');

    const GuardedAnalyticsPage = () => {
      const { canViewAnalytics, analyticsAccessLoading } = useAnalyticsAccess();

      if (analyticsAccessLoading) return <LoadingFallback />;
      if (!canViewAnalytics) {
        return (
          <Navigate
            to={routerPaths.callCenter}
            replace
          />
        );
      }

      return <AnalyticsPage />;
    };

    return { default: GuardedAnalyticsPage };
  },
  {
    fallback: <LoadingFallback />,
  },
);

const routes = [
  {
    element: <AppWrapper />,
    errorElement: <ErrorBoundaryFallBack />,
    children: [
      {
        path: routerPaths.root,
        element: (
          <Navigate
            to={routerPaths.login}
            replace
          />
        ),
      },
      {
        element: <Layout />,
        children: [
          {
            path: `${routerPaths.callCenter}`,
            element: <CallCenter />,
          },
          {
            path: `${routerPaths.analytics}`,
            element: <Analytics />,
          },
        ],
      },
      {
        path: routerPaths.login,
        element: <Login />,
      },
    ],
  },
];

const projectRouters = createBrowserRouter(routes);

export default projectRouters;
